import { isValid } from 'date-fns';
// TODO: Fix exports
// eslint-disable-next-line no-restricted-imports
import { inputDateFormatter } from 'design-system/components/input/date-component/formatters';
import humanizeDuration, { type Unit } from 'humanize-duration';

export const getDisplayDateTime = (date?: string | number) =>
  date ? inputDateFormatter.datetime(new Date(date)) : undefined;

export const getDisplayDate = (date?: string) =>
  date ? inputDateFormatter.date(new Date(date)) : undefined;

const parseDate = (isoDate?: string | number): Date | undefined => {
  if (typeof isoDate === 'number') {
    return new Date(isoDate);
  }

  if (!isoDate) {
    return undefined;
  }

  const parsed = new Date(isoDate);

  if (!isValid(parsed)) {
    return undefined;
  }

  return parsed;
};

const getRelativeAge = (
  isoDate?: string,
  relative = new Date(),
): number | undefined => {
  const parsed = parseDate(isoDate);

  if (!parsed) {
    return undefined;
  }

  const age = relative.getTime() - parsed.getTime();

  return age;
};

/**
 * Get the display for a duration of time in the specified unit, rounded
 */
export const getSingleDurationDisplay = (
  unit: Unit,
  isoDate?: string,
): string | undefined => {
  const age = getRelativeAge(isoDate);

  if (!age) {
    return undefined;
  }

  return humanizeDuration(age, {
    largest: 1,
    round: true,
    units: [unit],
  });
};
